/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const updateAckStatus = React.createContext({});
export let updateAckStatusMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMUpdateAckStatus = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  updateAckStatusMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(updateAckStatusMachine);

  return {
    updateAckStatusMachine,
    updateAckStatusState: state,
    updateAckStatusSend: send,
  };
};
